export default "<db:a><a\n\tdata-id='href'\n\tdata-property='href'><span data-id='body'></span></a\n></db:a>";